var labels = {
  general: {
    message_title: {
      es: 'Mensaje',
      en: 'Message'
    },
    confirm: {
      es: 'Confirmación',
      en: 'Confirmation'
    },
    confirm_yes: {
      es: 'Si',
      en: 'Yes'
    },
    confirm_back: {
      es: 'Salir',
      en: 'Go out'
    },
    confirm_download: {
      es: 'La descarga del archivo se completó correctamente',
      en: 'The file download was completed successfully'
    },
    confirm_save_message: {
      es: 'Se guardó correctamente',
      en: 'Saved successfully'
    },
    confirm_save_title: {
      es: 'Éxito',
      en: 'Success'
    },
    confirm_process_message: {
      es: "La información se procesó correctamente",
      en: "The information was processed successfully"
    },
    text_modal_delete: {
      es: '¿Desea eliminar el registro?',
      en: 'Do you want to delete the record?'
    },
    confirm_delete_message: {
      es: 'Se eliminó el registro',
      en: 'The record was deleted'
    },
    error_title: {
      es: 'Error',
      en: 'Error'
    },
    error_proccessing: {
      es: 'Hubo un error al procesar la información',
      en: 'There was an error processing the information'
    },
    filter_required: {
      es: 'Debe completar al menos uno de los campos del filtro',
      en: 'You must complete at least one of the filter fields'
    },
    unexpected_error: {
      es: 'Ocurrió un error inesperado',
      en: 'An unexpected error occurred'
    },
    showing: {
      es: 'Mostrando',
      en: 'Showing'
    },
    of: {
      es: 'de',
      en: 'of'
    },
    total: {
      es: 'Total',
      en: 'Total'
    },
    records: {
      es: 'registros',
      en: 'records'
    },
    no_records_found: {
      es: 'No se encontraron registros',
      en: 'No records found'
    },
    message_empty_file: {
      es: 'El archivo está vacío',
      en: 'The file is empty'
    },
    confirm_process_preview: {
      es: 'La información se visualiza en resumen',
      en: 'The information is displayed in summary'
    }
  },
  listCampaignPage: {
    title: {
      es: 'Configuración de Campañas',
      en: 'Campaign Configuration'
    },
    actionsButtons: {
      uploadHistory: {
        es: 'Histórico de cargas',
        en: 'Load history'
      },
      downloadTemplateRules: {
        es: 'Plantilla',
        en: 'Template'
      },
      downloadRulesHistory: {
        es: 'Histórico de reglas',
        en: 'Rules History'
      },
      downloadCampaingCsv: {
        es: 'Descargar',
        en: 'Download'
      },
      uploadRules: {
        es: 'Cargar Reglas',
        en: 'Load Rules'
      },
      process: {
        es: 'Procesar',
        en: 'Process'
      },
      tooltipProcess: {
        es: 'Se procesarán las campañas que tengan reglas configuradas<br>y con fecha de fin de vigencia igual o posterior a hoy.',
        en: 'Campaigns with configured rules<br>and an end date on or after today will be processed'
      }
    },
    filter: {
      company: {
        es: 'Compañía',
        en: 'Company'
      },
      flash_campaign_type: {
        es: 'Tipo Flash',
        en: 'Flash Type'
      },
      digital_campaign_type: {
        es: 'Tipo Digital',
        en: 'Digital Type'
      },
      name: {
        es: 'Descripción del Cupón',
        en: 'Coupon Description'
      },
      type: {
        es: 'Tipo Campaña',
        en: 'Campaign Type'
      },
      effectiveDate: {
        es: 'Fecha de Vigencia',
        en: 'Effective Date'
      },
      creationDate: {
        es: 'Fecha de Creación Origen',
        en: 'Origin Creation Date'
      },
      creationDateInca: {
        es: 'Fecha de Creación INCA',
        en: 'INCA Creation Date'
      },
      modificationRules: {
        es: 'Fecha de Modificación de Reglas',
        en: 'Rules Modification Date'
      },
      code_campaign: {
        es: 'Código de campaña',
        en: 'Campaign code'
      },
      rules_modified_time: {
        es: 'Horas desde la última modificación de reglas',
        en: 'Hours since last rules modification'
      },
      other_modified_time: {
        es: 'Especificar cantidad de horas',
        en: 'Specify number of hours'
      },
      flag_recommendation_processed: {
        es: 'Enviadas a proceso de recomendación',
        en: 'Sent to recommendation process'
      },
      flag_pending_rule_configured: {
        es: 'Pendiente de configurar reglas',
        en: 'Pending rule configuration'
      },
      campaign_status_inca: {
        es: 'Estado',
        en: 'Status'
      },
      validity_type: {
        es: 'Tipo de Vigencia',
        en: 'Validity Type'
      },
      coupon_channel_type: {
        es: 'Canal de Cupón',
        en: 'Coupon Channel Type'
      },
      flag_api_recommendation: {
        es: 'API de Recomendación',
        en: 'API Recommendation'
      }
    },
    grid: {
      columns: {
        number: {
          es: 'N°',
          en: 'N°'
        },
        campaign_code: {
          es: 'Código de Campaña',
          en: 'Campaign Code'
        },
        start_date: {
          es: 'Fecha de Inicio de Vigencia',
          en: 'Start Date'
        },
        end_date: {
          es: 'Fecha de Fin de Vigencia',
          en: 'End Date'
        },
        minimum_amount: {
          es: 'Monto Mínimo',
          en: 'Minimum Amount'
        },
        coupon_description: {
          es: 'Descripción del Cupón',
          en: 'Coupon Description'
        },
        campaign_status: {
          es: 'Estado de la Campaña',
          en: 'Campaign Status'
        },
        flash_campaign_type: {
          es: 'Tipo Flash',
          en: 'Flash Type'
        },
        digital_campaign_type: {
          es: 'Tipo Digital',
          en: 'Digital Type'
        },
        coupon_channel_type: {
          es: 'Canal de Cupón',
          en: 'Coupon Channel Type'
        },
        flag_api_recommendation: {
          es: 'API de Recomendación',
          en: 'API Recommendation'
        },
        campaign_creation_date_inca: {
          es: 'Fecha de Creación INCA',
          en: 'INCA Creation Date'
        },
        campaign_creation_date: {
          es: 'Fecha de Creación de Origen',
          en: 'Origin Creation Date'
        },
        campaign_modification_date: {
          es: 'Fecha de Modificación de Origen',
          en: 'Origin Modification Date'
        },
        campaign_priority: {
          es: 'Orden',
          en: 'Order'
        },
        usage_start_date: {
          es: 'Fecha de Inicio de Uso',
          en: 'Usage Start Date'
        },
        usage_end_date: {
          es: 'Fecha de Fin de Uso',
          en: 'Usage End Date'
        },
        campaign_discount_type: {
          es: 'Tipo de Descuento',
          en: 'Discount Type'
        },
        campaign_ominical_indicator: {
          es: 'Indicador de Ominical',
          en: 'Ominical Indicator'
        },
        type_flash_campaign: {
          es: 'Tipo de Campaña Flash',
          en: 'Flash Campaign Type'
        },
        type_digital_campaign: {
          es: 'Tipo de Campaña Digital',
          en: 'Digital Campaign Type'
        },
        campaign_brand_code: {
          es: 'Código de Marca',
          en: 'Brand Code'
        },
        instant_campaign_indicator: {
          es: 'Campaña Instantánea',
          en: 'Instant Campaign'
        },
        digital_campaign_type_2: {
          es: 'Tipo de Campaña',
          en: 'Campaign Type'
        },
        variable_group_data: {
          es: 'Datos del Grupo de Variables',
          en: 'Variable Group Data'
        },
        actions: {
          es: 'Acciones',
          en: 'Actions'
        }
      },
      actions: {
        rules: {
          es: 'Reglas',
          en: 'Rules'
        },
        details: {
          es: 'Ver Detalle',
          en: 'View Details'
        },
        downloadProducts: {
          es: 'Descargar productos',
          en: 'Download products'
        },
        downloadRules: {
          es: 'Descargar reglas',
          en: 'Download rules'
        },
        viewUploadHistory: {
          es: 'Ver histórico de cargas',
          en: 'View upload history'
        }
      },
      message_validation: {
        title_message: {
          es: 'Requerido',
          en: 'Requested'
        },
        message: {
          es: 'Debe seleccionar al menos una opción de grupo de variable.',
          en: 'You must select at least one variable group option.'
        }
      }
    },
    message_upload_failed: {
      title_message: {
        es: 'No procesado',
        en: 'Not processed'
      },
      message: {
        es: 'El archivo no pudo procesarse. Revise los errores en el archivo descargado.',
        en: 'The rules were loaded successfully. Would you like to send the campaigns for processing?'
      }
    },
    message_upload_success: {
      title_message: {
        es: 'No procesado',
        en: 'Not processed'
      },
      message: {
        es: 'Se cargó correctamente las reglas. ¿Desea enviar a Procesar las campañas?',
        en: 'The file could not be processed. Review the errors in the downloaded file.'
      }
    },
    message_process_started: {
      processConfirmation: {
        es: 'Se ha iniciado el proceso de envío. Para consultar su estado, revise el historial de procesos.',
        en: 'The sending process has been started. To check its status, please review the process history.'
      }
    },
    message_process_started_upload_rules: {
      processConfirmation: {
        es: 'Se ha iniciado la solicitud de Procesar las campañas cargadas.',
        en: 'The request to process the campaigns loaded has been started.'
      }
    },
    message_processing_bg: {
      title_message: {
        es: 'Procesando',
        en: 'Processing'
      },
      message: {
        es: 'La campaña está siendo procesada. Por favor, espere a que termine, puede consultar el historial de procesos.',
        en: 'The campaign is being processed. Please wait for the process to finish, you can review the process history.'
      }
    }
  },
  listCampaignHistoryPage: {
    title: {
      es: 'Historial de Carga de Campañas',
      en: 'Campaigns Upload History'
    },
    actionsButtons: {
      backCampaign: {
        es: 'Volver',
        en: 'Back'
      },
      downloadHistoryCampaigns: {
        es: 'Descargar',
        en: 'Download'
      }
    },
    filter: {
      process_name: {
        es: 'Nombre del proceso',
        en: 'Process Name'
      },
      process_date: {
        es: 'Fecha del proceso',
        en: 'Process Date'
      },
      source_name: {
        es: 'Nombre del archivo',
        en: 'File Name'
      }
    },
    grid: {
      columns: {
        number: {
          es: 'N°',
          en: 'No.'
        },
        source_name: {
          es: 'Nombre del archivo',
          en: 'File name'
        },
        process_status: {
          es: 'Estado',
          en: 'Status'
        },
        start_time: {
          es: 'Fecha de proceso de Inicio',
          en: 'Start date of the process'
        },
        end_time: {
          es: 'Fecha de proceso de Fin',
          en: 'End date of the process'
        },
        total_records: {
          es: 'Total de Registros',
          en: 'Total Records'
        },
        uploaded_records: {
          es: 'Total de registros cargados',
          en: 'Total records updated'
        },
        rejected_records: {
          es: 'Total de registros rechazados',
          en: 'Total rejected records'
        },
        process_date: {
          es: 'Fecha del proceso',
          en: 'Date of the process'
        },
        process_name: {
          es: 'Nombre del proceso',
          en: 'Process name'
        },
        summary: {
          es: 'Resumen',
          en: 'Summary'
        },
        actions: {
          es: 'Acciones',
          en: 'Actions'
        }
      },
      actions: {
        download: {
          es: 'Descargar',
          en: 'Download'
        }
      },
      tooltip: {
        downloadInformation: {
          es: 'Descargar información',
          en: 'Download information'
        }
      }
    }
  },
  rulesCampaignPage: {
    title: {
      es: 'Configuración de Campañas - Reglas',
      en: 'Campaign Configuration - Rules'
    },
    generalData: {
      title: {
        es: 'Datos de Campaña',
        en: 'Campaign Data'
      },
      fields: {
        code: {
          es: 'Código Homologado',
          en: 'Standardized Code'
        },
        start_date: {
          es: 'Fecha de Inicio',
          en: 'Start Date'
        },
        end_date: {
          es: 'Fecha de Fin',
          en: 'End Date'
        },
        description: {
          es: 'Descripción',
          en: 'Description'
        }
      }
    },
    tabs: {
      configuration: {
        es: 'Configuración',
        en: 'Configuration'
      },
      products: {
        es: 'Productos',
        en: 'Products'
      }
    },
    tabConfiguration: {
      acctionsButtons: {
        back: {
          es: 'Volver',
          en: 'Back'
        },
        save: {
          es: 'Guardar',
          en: 'Save'
        },
        preview: {
          es: 'Previsualizar',
          en: 'Preview'
        },
        process: {
          es: 'Procesar',
          en: 'Process'
        }
      },
      tool_tips: {
        upload: {
          es: 'Cargar archivo',
          en: 'Uplaod file'
        },
        download: {
          es: 'Descargar archivo',
          en: 'Download file'
        },
        delete: {
          es: 'Eliminar archivo',
          en: 'Delete file'
        },
        searchSegment: {
          es: 'Buscar segmento',
          en: 'Search segment'
        },
        clearSelection: {
          es: 'Eliminar selección',
          en: 'Remove selection'
        },
        process: {
          es: 'Esta campaña se procesará solo si tiene reglas configuradas<br>y su fecha de fin de vigencia es igual o posterior a hoy.',
          en: 'This campaign will be processed only if it has configured rules<br>and its end date is on or after today.'
        }
      },
      messages: {
        noRecordsAvailable: {
          es: 'No hay registros disponibles para descargar',
          en: 'There are no records available to download'
        },
        fileSelected: {
          es: 'Archivo seleccionado',
          en: 'File selected'
        },
        fileUploaded: {
          es: 'Archivo cargado correctamente',
          en: 'File uploaded successfully'
        },
        invalidHeader: {
          es: 'El archivo debe tener una cabecera llamada "items"',
          en: 'The file must have a header named "items"'
        },
        noRecordsToLoad: {
          es: 'El archivo no contiene registros para cargar.',
          en: 'The file contains no records to load.'
        },
        processConfirmation: {
          es: 'Se procesó correctamente la campaña para su revisión.',
          en: 'The campaign has been successfully processed for review.'
        },
        processError: {
          es: 'Hubo un error al procesar la campaña para mayor detalle ingrese al historial de carga',
          en: 'There was an error processing the campaign. For more details, see the upload history.'
        },
        processCloneVariablesSuccess: {
          es: 'Las variables se han clonado correctamente.',
          en: 'The variables have been cloned successfully.'
        },
        inverseExclusionWarning: {
          es: 'La campaña {selected} ya tiene una exclusión para esta campaña {current}. No puede realizar una recursividad de exclusiones. Revise la configuración de la campaña {selected}.',
          en: 'Campaign {selected} already has an exclusion for this campaign {current}. Cannot perform a recursive exclusion. Review the configuration of campaign {selected}.'
        }
      }
    },
    tabProducts: {
      filter: {
        code: {
          es: 'Código Producto',
          en: 'Product Code'
        },
        name: {
          es: 'Nombre Producto',
          en: 'Product Name'
        },
        creation_date: {
          es: 'Fecha de Registro',
          en: 'Registration Date'
        }
      },
      downloadProducts: {
        es: 'Descargar',
        en: 'Download'
      }
    },
    gridProducts: {
      title: {
        es: 'Listado de Productos',
        en: 'Product List'
      },
      columns: {
        number: {
          es: 'N°',
          en: 'N°.'
        },
        item_code: {
          es: 'Código Producto',
          en: 'Product Code'
        },
        item_name: {
          es: 'Nombre Producto',
          en: 'Product Name'
        },
        item_status: {
          es: 'Estado',
          en: 'Status'
        },
        item_source_creation_time: {
          es: 'Fecha Creación Origen',
          en: 'Source Creation Date'
        },
        item_offering_mode: {
          es: 'Modo Oferta',
          en: 'Offering Mode'
        },
        item_offering_amount: {
          es: 'Monto Oferta',
          en: 'Offering Amount'
        },
        item_discount_type: {
          es: 'Tipo Descuento',
          en: 'Discount Type'
        },
        item_discount_mode: {
          es: 'Modo Descuento',
          en: 'Discount Mode'
        },
        item_discount_value: {
          es: 'Valor Descuento',
          en: 'Discount Value'
        }
      }
    },
    modal_segment_selection: {
      title: {
        es: 'Mis Segmentos',
        en: 'My Segments'
      },
      grid_segment: {
        title: {
          es: 'Listado de Segmentos',
          en: 'Segment List'
        },
        filter: {
          name: {
            es: 'Nombre del Segmento',
            en: 'Segment Name'
          },
          type_name: {
            es: 'Tipo de Segmento',
            en: 'Segment Type'
          },
          created_date: {
            es: 'Fecha de Creación',
            en: 'Creation Date'
          },
          modified_date: {
            es: 'Fecha de Modificación',
            en: 'Modification Date'
          },
          is_shared: {
            es: '¿Es Compartido?',
            en: 'Is Shared?'
          },
          request_data: {
            es: 'Por Solicitud de Datos',
            en: 'By Data Request'
          }
        },
        columns: {
          number: {
            es: 'N°',
            en: 'No.'
          },
          name: {
            es: 'Nombre',
            en: 'Name'
          },
          type_name: {
            es: 'Tipo',
            en: 'Type'
          },
          created_time: {
            es: 'Fecha de Creación',
            en: 'Creation Date'
          },
          modified_time: {
            es: 'Fecha de Modificación',
            en: 'Modification Date'
          },
          unique_users: {
            es: 'Usuarios Únicos',
            en: 'Unique Users'
          },
          total_audiences: {
            es: 'Total Audiencias',
            en: 'Total Audiences'
          },
          actions: {
            es: 'Acciones',
            en: 'Actions'
          }
        }
      }
    },
    modal_select_segment: {
      message_confirmation: {
        es: '¿Seguro que quieres seleccionar el segmento?',
        en: 'Are you sure you want to select the segment?'
      },
      segment_selection_success: {
        es: 'El segmento se ha seleccionado correctamente.',
        en: 'The segment has been selected successfully.'
      }
    },
    select_segment_icons: {
      icons: {
        text_tooltip_add_segment: {
          es: 'Seleccionar Segmento',
          en: 'Select Segment'
        }
      }
    }
  },
  listVariablePage: {
    title: {
      es: 'Configuración de Variables',
      en: 'Variable Configuration'
    },
    actionsButtons: {
      downloadTemplate: {
        es: 'Plantilla',
        en: 'Template'
      },
      uploadVariables: {
        es: 'Cargar',
        en: 'Upload'
      },
      createNewVariableGroup: {
        es: 'Nuevo',
        en: 'New'
      },
      errorReadFile: {
        es: 'Error al leer el archivo csv',
        en: 'Error reading csv file'
      },
      errorNoFile: {
        es: 'No se seleccionó ningún archivo',
        en: 'No file selected'
      },
      errorInvalidHeaders: {
        es: 'El archivo debe tener cabeceras "codigo_de _variable, nombre_de_variable"',
        en: 'The file must have headers "codigo_de_variable, nombre_de_variable"'
      },
      errorFileIsEmpty: {
        es: 'El archivo está vacío',
        en: 'The file is empty'
      },
      errorEmptyFields: {
        es: 'Fila {row}: Código o nombre de variable vacío',
        en: 'Row {row}: Variable code or name is empty'
      },
      errorInvalidCode: {
        es: 'Fila {row}: variable_code "{code}" contiene caracteres no permitidos',
        en: 'Row {row}: variable_code "{code}" contains invalid characters'
      },
      uploadSuccess: {
        es: 'Variables registradas correctamente',
        en: 'Variables successfully registered'
      },
      uploadFail: {
        es: 'Error al registrar las variables',
        en: 'Error while registering variables'
      },
      uploadUnexpectedError: {
        es: 'Ocurrió un error inesperado al registrar las variables',
        en: 'An unexpected error occurred while registering variables'
      }
    },
    tabs: {
      variables: {
        es: 'Variables',
        en: 'Variables'
      },
      variable_group: {
        es: 'Grupo de Variables',
        en: 'Variable Group'
      }
    },
    grid_variable: {
      filter: {
        variable_code: {
          es: 'Código de Variable',
          en: 'Variable Code'
        },
        variable_name: {
          es: 'Nombre de Variable',
          en: 'Variable Name'
        },
        variable_type: {
          es: 'Tipo de Atributo',
          en: 'Attribute Type'
        }
      },
      columns: {
        number: {
          es: 'N°',
          en: 'N°'
        },
        code_variable: {
          es: 'Código de Variable',
          en: 'Variable Code'
        },
        name_variable: {
          es: 'Nombre de Variable',
          en: 'Variable Name'
        },
        description: {
          es: 'Descripción',
          en: 'Description'
        },
        variable_type: {
          es: 'Tipo de Atributo',
          en: 'Attribute Type'
        },
        flg_required: {
          es: 'Es Obligatorio',
          en: 'Is Required'
        },
        flg_has_object: {
          es: 'Asociar a mis Objetos',
          en: 'Associate with My Objects'
        },
        configuration: {
          es: 'Configuración',
          en: 'Configuration'
        }
      },
      message_validation: {
        message: {
          es: 'Seleccione el tipo de atributo.',
          en: 'Select the attribute type.'
        }
      },
      icons: {
        text_tool_tip_save: {
          es: 'Guardar',
          en: 'Save'
        },
        text_tool_tip_configuration: {
          es: 'Configuración',
          en: 'Configuration'
        },
        text_tool_tip_object: {
          es: 'Ver objectos',
          en: 'View objects'
        },
        text_tool_tip_delete: {
          es: 'Eliminar',
          en: 'Delete'
        }
      }
    },
    modal_delete_variable: {
      message_confirmation: {
        es: '¿Seguro que quieres eliminar la variable?',
        en: 'Do you really want to delete the variable?'
      },
      delete_error: {
        es: 'Error al eliminar la variable.',
        en: 'Error deleting the variable.'
      }
    },
    grid_variable_group: {
      filter: {
        name_variable_group: {
          es: 'Nombre de Grupo de Variables',
          en: 'Variable Group Name'
        },
        creation_date: {
          es: 'Fecha de Creación',
          en: 'Creation Date'
        }
      },
      columns: {
        number: {
          es: 'N°',
          en: 'N°'
        },
        name_variable_group: {
          es: 'Nombre de Grupo de Variables',
          en: 'Variable Group Name'
        },
        priority: {
          es: 'Prioridad',
          en: 'Priority'
        },
        creation_date: {
          es: 'Fecha de Creación',
          en: 'Creation Date'
        },
        modification_date: {
          es: 'Fecha de Última Modificación',
          en: 'Last Modification Date'
        },
        actions: {
          es: 'Acciones',
          en: 'Actions'
        }
      },
      actions: {
        edit: {
          es: 'Editar',
          en: 'Edit'
        },
        delete: {
          es: 'Eliminar',
          en: 'Delete'
        }
      }
    },
    modal_detail_campaign: {
      title: {
        es: 'Información de la campaña',
        en: 'Campaign information'
      },
      sub_title: {
        es: 'Información de la campaña',
        en: 'Campaign information'
      }
    },
    modal_variable_configuration: {
      title: {
        es: 'Configuración de Variable',
        en: 'Variable Configuration'
      },
      form: {
        variable_min_range: {
          es: 'Rango Mínimo',
          en: 'Minimum Range'
        },
        variable_max_range: {
          es: 'Rango Máximo',
          en: 'Maximum Range'
        },
        variable_code: {
          es: 'Código de Variable',
          en: 'Variable Code'
        },
        variable_name: {
          es: 'Nombre de Variable',
          en: 'Variable Name'
        },
        variable_description: {
          es: 'Descripción de la variable',
          en: 'Variable Description'
        },
        flag_required: {
          es: 'Es Obligatorio',
          en: 'Is Required'
        },
        flag_range: {
          es: 'Rango',
          en: 'Range'
        },
        flag_object: {
          es: 'Asociar a mis Objetos',
          en: 'Associate with My Objects'
        },
        flag_campaign_client_result: {
          es: 'Resultado de Campaña por Cliente',
          en: 'Campaign Result by Client'
        },
        flag_client_ids: {
          es: 'ID de Cliente',
          en: 'Client ID'
        },
        flag_operator: {
          es: 'Operador',
          en: 'Operator'
        },
        flag_multiple_select: {
          es: 'Selección Múltiple',
          en: 'Multiple Selection'
        },
        flag_parent_variable_exists: {
          es: 'Variable Padre Existe',
          en: 'Parent Variable Exists'
        },
        flag_info_campaign: {
          es: 'Información de Campaña',
          en: 'Campaign Information'
        },
        flag_upload_data: {
          es: 'Subir Archivo',
          en: 'Upload File'
        },
        flag_save_param_list: {
          es: 'Guardar Parámetro de Lista',
          en: 'Save List Parameter'
        },
        variable_type_big_query: {
          es: 'Tipo de Atributo BigQuery',
          en: 'BigQuery Attribute Type'
        },
        id_variable_parent: {
          es: 'Variable Padre',
          en: 'Parent variable'
        },
        flag_info_segment: {
          es: 'Información de Segmento',
          en: 'Segment Information'
        },
        default_operator: {
          es: 'Operador',
          en: 'Operator'
        },
        id_variable_type: {
          es: 'Tipo de Atributo',
          en: 'Attribute Type'
        },
        flag_recommendation_section: {
          es: 'Sección de recomendacion Prioridad 1',
          en: 'Recommendations section priority 1'
        },
        flag_recommendation_section_priority_2: {
          es: 'Sección de recomendacion Prioridad 2',
          en: 'Recommendations section priority 2'
        },
        flag_component_company: {
          es: 'Aplicar componente personalizado',
          en: 'Apply Custom Component'
        },
        flag_variable_campaign_order: {
          es: 'Aplicar orden de variable en Campaña',
          en: 'Apply Variable Order in Campaign'
        }
      },
      rules: {
        message_required: {
          es: 'Este campo es requerido',
          en: 'This field is required'
        },
        message_numeric: {
          es: 'El valor debe ser numérico',
          en: 'The value must be numeric'
        },
        message_grid: {
          es: 'Debe ingresar al menos un registro en la tabla.',
          en: 'You must enter at least one record in the table.'
        },
        message_grid_input: {
          es: 'Debe completar toda la información en la sección Datos.',
          en: 'You must complete all information in the Data section.'
        },
        message_empty_file: {
          es: 'El archivo está vacío o sin registros.',
          en: 'The file is empty or has no records.'
        },
        message_no_valid_records: {
          es: 'No se cargó ningún registro válido.',
          en: 'No valid records were loaded.'
        },
        message_error_reading_file: {
          es: 'Ocurrió un error al leer el archivo.',
          en: 'An error occurred while reading the file.'
        }
      },
      tab_general: {
        title_general: {
          es: 'General',
          en: 'General'
        }
      },
      tab_date: {
        title_data: {
          es: 'Datos',
          en: 'Data'
        },
        grid_data: {
          columns: {
            number: {
              es: 'N°',
              en: 'N°'
            },
            data_key: {
              es: 'Código',
              en: 'Code'
            },
            data_value: {
              es: 'Valor',
              en: 'Value'
            },
            parent_data_key: {
              es: 'Código Padre',
              en: 'Parent Code'
            },
            actions: {
              es: 'Acciones',
              en: 'Actions'
            }
          },
          actions: {
            add_record: {
              es: 'Agregar',
              en: 'Add'
            }
          }
        },
        buttons: {
          downloadTemplate: {
            es: 'Descargar',
            en: 'Download'
          },
          uploadTemplate: {
            es: 'Cargar',
            en: 'Upload'
          }
        }
      }
    },
    modal_list_objects: {
      title: {
        es: 'Mis Objetos',
        en: 'My Objects'
      },
      form: {
        variable_code: {
          es: 'Código de Variable',
          en: 'Variable Code'
        },
        variable_name: {
          es: 'Nombre de Variable',
          en: 'Variable Name'
        },
        variable_description: {
          es: 'Descripción de la variable',
          en: 'Variable Description'
        },
        id_variable_type: {
          es: 'Tipo de Atributo',
          en: 'Attribute Type'
        }
      },
      grid_table: {
        title: {
          es: 'Listado de Objetos',
          en: 'Object List'
        },
        filter: {
          table: {
            es: 'Nombre de la Tabla',
            en: 'Table Name'
          },
          creation_date: {
            es: 'Fecha de Creación',
            en: 'Creation Date'
          }
        },
        columns: {
          number: {
            es: 'N°',
            en: 'N°'
          },
          table: {
            es: 'Tabla',
            en: 'Table'
          },
          creationTime: {
            es: 'Fecha de Creación',
            en: 'Creation Date'
          },
          lastModifiedTime: {
            es: 'Fecha de Modificación',
            en: 'Last Modified Time'
          },
          actions: {
            es: 'Acciones',
            en: 'Actions'
          }
        }
      },
      grid_column: {
        title: {
          es: 'Listado de Columnas de Objetos Seleccionados',
          en: 'Selected Object Columns'
        },
        filter: {
          column_name: {
            es: 'Nombre de la Columna',
            en: 'Column Name'
          },
          definition_business: {
            es: 'Definición de negocios',
            en: 'Business Definition'
          },
          name_element_date: {
            es: 'Nombre de elemento de datos',
            en: 'Data Element Name'
          }
        },
        columns: {
          number: {
            es: 'N°',
            en: 'N°'
          },
          column: {
            es: 'Columna',
            en: 'Column'
          },
          associated_field: {
            es: 'Campo Asociado',
            en: 'Associated Field'
          },
          join_field_id: {
            es: 'Campo ID Join',
            en: 'Join Field ID'
          },
          actions: {
            es: 'Script',
            en: 'Script'
          }
        }
      }
    },
    modal_script: {
      title: {
        es: 'Editar Script',
        en: 'Edit Script'
      },
      column_parser_script: {
        es: 'Script asociado a la columna',
        en: 'Script linked to the column'
      }
    },
    grid_edit_variable: {
      title: {
        es: 'Listado de Variables',
        en: 'List of Variables'
      },
      filter: {
        code_variable: {
          es: 'Código de Variable',
          en: 'Variable Code'
        },
        name_variable: {
          es: 'Nombre de Variable',
          en: 'Variable Name'
        },
        creation_date: {
          es: 'Fecha de Creación',
          en: 'Creation Date'
        }
      },
      columns: {
        order: {
          es: '',
          en: ''
        },
        number: {
          es: 'Orden',
          en: 'Order'
        },
        code_variable: {
          es: 'Código de Variable',
          en: 'Variable Code'
        },
        name_variable: {
          es: 'Nombre de Variable',
          en: 'Variable Name'
        },
        description: {
          es: 'Descripción',
          en: 'Description'
        },
        variable_type: {
          es: 'Tipo de Atributo',
          en: 'Attribute Type'
        },
        flg_required: {
          es: 'Es Obligatorio',
          en: 'Is Required'
        },
        actions: {
          es: 'Acciones',
          en: 'Actions'
        }
      },
      icons: {
        text_tool_tip_rigth: {
          es: 'Agregar a grupo de variables',
          en: 'Add to a variable group'
        },
        add_confirmation_message: {
          es: '¿Desea agregar esta variable al grupo?',
          en: 'Do you want to add this variable to the group?'
        }
      }
    },
    grid_edit_variable_group: {
      title_create: {
        es: 'Crear Grupo de Variables',
        en: 'Create Variable Group'
      },
      title_edit: {
        es: 'Editar Grupo de Variable',
        en: 'Edit Variable Group'
      },
      generalData: {
        fields: {
          name_variable_group: {
            es: 'Nombre de Grupo de Variable',
            en: 'Variable Group Name'
          },
          priority: {
            es: 'Prioridad',
            en: 'Priority'
          },
          message_grid: {
            es: 'Debe agregar al menos una variable al grupo',
            en: 'You must add at least one variable to the group'
          }
        }
      },
      title: {
        es: 'Variables Seleccionadas',
        en: 'Selected Variables'
      },
      columns: {
        number: {
          es: 'N°',
          en: 'N°'
        },
        code_variable: {
          es: 'Código de Variable',
          en: 'Variable Code'
        },
        name_variable: {
          es: 'Nombre de Variable',
          en: 'Variable Name'
        },
        description: {
          es: 'Descripción',
          en: 'Description'
        },
        variable_type: {
          es: 'Tipo de Atributo',
          en: 'Attribute Type'
        },
        flg_required: {
          es: 'Es Obligatorio',
          en: 'Is Required'
        },
        actions: {
          es: 'Acciones',
          en: 'Actions'
        }
      },
      icons: {
        text_tool_tip_left: {
          es: 'Quitar del grupo de variables',
          en: 'Remove from a variable group'
        },
        deletion_confirmation_message: {
          es: '¿Desea quitar esta variable del grupo?',
          en: 'Do you want to remove this variable from the group?'
        }
      },
      rules: {
        message_required: {
          es: 'Este campo es requerido',
          en: 'This field is required'
        },
        message_min_limit_characters: {
          es: 'Debe tener al menos',
          en: 'Must have at least'
        },
        message_characters: {
          es: 'caracteres',
          en: 'characters'
        }
      }
    }
  }
};
export default labels;